import { render, staticRenderFns } from "./vendorInfo.vue?vue&type=template&id=1bb6cb6c&scoped=true&"
import script from "./vendorInfo.vue?vue&type=script&lang=js&"
export * from "./vendorInfo.vue?vue&type=script&lang=js&"
import style0 from "./vendorInfo.vue?vue&type=style&index=0&id=1bb6cb6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6cb6c",
  null
  
)

export default component.exports